import React, { useEffect } from "react";
import { Drawer, Form, Input, Menu, Modal } from "antd";
import {
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Empty,
  Timeline,
  Button,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import {
  getClientDetails,
  updateClientAccount,
  updateClientAuth,
  getClientStatic,
  updateUnitCost,
  updateClient,
  updateClientPassword,
} from "../../actions/clients";

import { Title, Wrapper } from "./detailStyle";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import Remarks from "../../component/remark";
import {
  CheckSquareFilled,
  EditOutlined,
  KeyOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import {
  renderInput,
  renderSelect,
  renderTextField,
} from "../../component/form/form";
const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};
const comapny = [
  { value: "individual", label: "Person" },
  { value: "company", label: "Company" },
];

const ClientDetails = ({
  location,
  getClientDetails,
  updateClientAuth,
  updateClientAccount,
  updateUnitCost,
  updateClient,
  getClientStatic,
  updateClientPassword,
}) => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [remark, setRemark] = useState(false);
  const [remarkaccount, setRemarkAccount] = useState(false);
  const [visibleP, setVisibleP] = useState(false);
  const [auth, setAuth] = useState(false);
  const [active, setActive] = useState(false);
  const [form] = Form.useForm();
  const [visibleC, setVisibleC] = useState(false);
  const [visible, setVisible] = useState(false);

  async function fetchData() {
    const email = new URLSearchParams(location.search).get("client");
    const res = await getClientDetails(email);
    form.setFieldsValue({
      unit_cost: res?.unit_cost,
    });
    const res1 = await getClientStatic(email);
    setData(res);
    setData1(res1);
  }
  async function fetchData1() {
    const email = new URLSearchParams(location.search).get("client");
    const res = await getClientDetails(email);
    
    setData(res);
    form.setFieldsValue({
      client: res?.user_id,
      remark: res?.remark,
      first_name: res?.first_name,
      last_name: res?.last_name,
      mobile_number: res?.mobile_number,
      email: res?.email,
      brand_name: res?.brand_name,
      client_type: res?.client_type,
      street_address: res?.address?.street_address,
      post_code: res?.address?.post_code,
      city: res?.address?.city,
      name: res?.company_detail?.name,
      Cmobile_number: res?.company_detail?.mobile_number,
      Cemail: res?.company_detail?.email,
      Cstreet_address: res?.company_detail?.address?.street_address,
      Cpost_code: res?.company_detail?.address?.post_code,
      Ccity: res?.company_detail?.address?.city,
    });
  }

  const Refresh = async () => {
    const res = await getClientDetails(data?.user_id);
    setData(res);
  };
  const handleOk = () => {
    setVisibleC(false);
  };

  const onClose = () => {
    setVisibleP(false);
  };

  const handleCancel = () => {
    setVisibleC(false);
  };

  useEffect(() => {
    fetchData();
    fetchData1();
  }, []);
  const onFinishP = async (values) => {
    const code = await updateClientPassword(values, data.user_id);
    if (code === 201) {
      setVisibleP(false);
    }
  };
  const onFinish = async (values) => {
    const code = await updateUnitCost(values, data.user_id);
    if (code === 201) {
      form.resetFields();
      Refresh();
      setVisible(false);
    }
  };
  const onFinishC = async (values) => {
    const code = await updateClient(values, data.user_id);
    if (code === 201) {
      Refresh();
      setVisibleC(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };

  const handleRefresh = async () => {
    const res = await getClientDetails(data?.user_id);
    setData(res);
    if (res === 201) {
      const res1 = await getClientStatic(data1?.user_id);
      setData1(res1);
    }
  };

  const makeLocalTime = (date) => {
    let hours = date?.split("T")[1].split(":")[0];
    let minutes = date?.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours === 12) {
      am = false;
    } else if (hours === 0) {
      hours = 12;
    }
    return (
      date?.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };

  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Client Details</Breadcrumb.Item>
      </Breadcrumb>

      <div>
        <Drawer
          title="Update Password"
          placement="bottom"
          closable={false}
          onClose={onClose}
          visible={visibleP}
          width="500"
        >
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishP}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="New Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "This field is required!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirm_password"
              rules={[
                {
                  required: true,
                  message: "This field is required!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Remark"
              name="remark"
              rules={[
                {
                  required: true,
                  message: "This field is required!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </div>

      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Client Details"
        subTitle="Client Management"
        extra={[
          <>
            <Button
              size="small"
              type="primary"
              icon={<EditOutlined />}
              onClick={() => {
                setVisibleC(true);
              }}
            >
              Edit
            </Button>

            <Button
              size="small"
              type="primary"
              icon={<KeyOutlined />}
              onClick={() => {
                setVisibleP(true);
              }}
            >
              Password Setting
            </Button>
          </>,
        ]}
      ></PageHeader>

      <Wrapper>
        <h2>
          Client Name : {data?.first_name} {data?.last_name}
        </h2>

        <Modal
          title="Client Details Update"
          centered
          visible={visibleC}
          onOk={handleOk}
          onCancel={handleCancel}
          width={1000}
        >
          {data ? (
            <Form
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              onFinish={onFinishC}
              onFinishFailed={onFinishFailed}
              style={{ alignSelf: "center" }}
              requiredMark={false}
              form={form}
            >
              {renderInput("first_name", "First Name", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("last_name", "Last Name", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("mobile_number", "Mobile", [
                { required: true, message: "This field is required!" },
                {
                  pattern: /^(01)[0-9][0-9]{8}$/,
                  message: "Please valid number!",
                },
              ])}
              {renderInput("email", "Email", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("brand_name", "Brand Name", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("street_address", "Street", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("post_code", "Post Code", [
                { required: true, message: "This field is required!" },
              ])}
              {renderInput("city", "City", [
                { required: true, message: "This field is required!" },
              ])}
              {renderSelect(
                "client_type",
                "Company Type",
                [{ required: true }],
                "Select Your Option",
                comapny,
                "none"
              )}
              {data?.client_type === "company" ? (
                <>
                  {renderInput("name", "Company Name", [
                    { required: true, message: "This field is required!" },
                  ])}
                  {renderInput("mobile_number", "Company Mobile", [
                    { required: true, message: "This field is required!" },
                  ])}
                  {renderInput("email", "Company Email", [
                    { required: true, message: "This field is required!" },
                  ])}

                  {renderInput("street_address", "Street", [
                    { required: true, message: "This field is required!" },
                  ])}
                  {renderInput("post_code", "Post Code", [
                    { required: true, message: "This field is required!" },
                  ])}
                  {renderInput("city", "City", [
                    { required: true, message: "This field is required!" },
                  ])}
                </>
              ) : null}

              {renderTextField("remark", "Remark", [
                { required: true, message: "This field is required!" },
              ])}

              <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
              </Form.Item>
            </Form>
          ) : null}
        </Modal>

        {data?.authenticated ? (
          <Tag color="#6fcf20">Authenticate</Tag>
        ) : (
          <Tag color="#e96710">Unauthenticate</Tag>
        )}
        <Tag color="#c237a4">{data?.created_at}</Tag>

        {data?.active_account ? (
          <Tag color="#6fcf20">Active Account</Tag>
        ) : (
          <Tag color="#e96710">Inactive Account</Tag>
        )}

        {!data?.authenticated ? (
          <Button
            type="ghost"
            icon={<CheckSquareFilled />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#568008",
              color: "#fff",
              marginLeft: "5px",
            }}
            onClick={() => {
              setAuth(true);
              setRemark(true);
            }}
          >
            Make Authenticate
          </Button>
        ) : (
          <Button
            type="ghost"
            icon={<WarningOutlined />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#f04545",
              color: "#fff",
              marginLeft: "5px",
            }}
            onClick={() => {
              setAuth(false);
              setRemark(true);
            }}
          >
            Make Unauthenticate
          </Button>
        )}

        {!data?.active_account ? (
          <Button
            type="ghost"
            icon={<CheckSquareFilled />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#568008",
              color: "#fff",
            }}
            onClick={() => {
              setActive(true);
              setRemarkAccount(true);
            }}
          >
            Make Active Account
          </Button>
        ) : (
          <Button
            type="ghost"
            icon={<WarningOutlined />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#f04545",
              color: "#fff",
            }}
            onClick={() => {
              setActive(false);
              setRemarkAccount(true);
            }}
          >
            Make Inactive Account
          </Button>
        )}

        <br />
        <br />
        {data ? (
          <>
            <Title>Client Information </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="ID">
                <strong>{data?.user_id}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="FIRST NAME">
                <strong>{data?.first_name?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="LAST NAME">
                <strong>{data?.last_name?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="MOBILE">
                <strong>{data?.mobile_number}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="EMAIL">
                <strong>{data?.email?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="Brand Name">
                <strong>{data?.brand_name?.toUpperCase()}</strong>
              </Descriptions.Item>

              <Descriptions.Item label="TYPE">
                <strong>
                  {data?.client_type === "individual" ? (
                    <p>PERSON</p>
                  ) : (
                    <p>COMPANY</p>
                  )}
                </strong>
              </Descriptions.Item>

              <Descriptions.Item label="UNIT COST">
                <strong>{data?.unit_cost}</strong>
                &nbsp;&nbsp;
                {data?.unit_cost === null ? (
                  <>
                    <Button
                      type="primary"
                      onClick={() => {
                        setVisible(true);
                      }}
                    >
                      Update
                    </Button>
                    <Drawer
                      title="Update Unit Cost"
                      placement="right"
                      closable={false}
                      visible={visible}
                      height={500}
                      width={500}
                      onClose={() => {
                        setVisible(false);
                      }}
                    >
                      {data ? (
                        <Form
                          name="basic"
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 16 }}
                          initialValues={{ remember: true }}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          style={{ alignSelf: "center" }}
                          requiredMark={false}
                          form={form}
                        >
                          {renderInput("unit_cost", "Unit Cost", [
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ])}
                          {renderTextField("remark", "Remark", [
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ])}

                          <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                              Update
                            </Button>
                          </Form.Item>
                        </Form>
                      ) : null}
                    </Drawer>
                  </>
                ) : (
                  <>
                    <Button
                      size="small"
                      type="primary"
                      icon={<EditOutlined />}
                      onClick={() => {
                        setVisible(true);
                      }}
                    >
                      Update
                    </Button>
                    <Drawer
                      title="Update Unit Cost"
                      placement={"bottom"}
                      width={500}
                      closable={false}
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                    >
                      {data ? (
                        <Form
                          name="basic"
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 16 }}
                          initialValues={{ remember: true }}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          style={{ alignSelf: "center" }}
                          requiredMark={false}
                          form={form}
                        >
                          {renderInput("unit_cost", "Unit Cost", [
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ])}
                          {renderTextField("remark", "Remark", [
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ])}

                          <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                              Update
                            </Button>
                          </Form.Item>
                        </Form>
                      ) : null}
                    </Drawer>
                  </>
                )}
              </Descriptions.Item>
              {data?.news_letter ? (
                <Descriptions.Item label="NEWS LETTER">
                  <strong>
                    <Tag color="#6fcf20">Subscribe</Tag>
                  </strong>
                </Descriptions.Item>
              ) : (
                <Descriptions.Item label="NEWS LETTER">
                  <strong>
                    <Tag color="#e96710">UnSubscribe</Tag>
                  </strong>{" "}
                </Descriptions.Item>
              )}
              <Descriptions.Item label="CITY">
                <strong>{data?.address?.city?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="STREET">
                <strong>{data?.address?.street_address?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="POST CODE">
                <strong>{data?.address?.post_code}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="BRAND IMAGE">
                <img
                  style={{ width: "60px" }}
                  src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.client_image}`}
                />
              </Descriptions.Item>
            </Descriptions>

            <Title>Total </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="TOTAL GENERATED CODE">
                <strong>{data1?.code_count}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="TOTAL BATCHES">
                <strong>{data1?.batch_count}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="TOTAL PRODUCT">
                <strong>{data1?.product_count}</strong>
              </Descriptions.Item>
            </Descriptions>

            <br />

            {data?.client_type === "company" ? (
              <>
                <Title>Company Information</Title>
                <br />
                <Descriptions>
                  <Descriptions.Item label="COMPANY NAME">
                    <strong>{data?.company_detail?.name}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="EMAIL">
                    <strong>{data?.company_detail?.email}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="MOBILE">
                    <strong>{data?.company_detail?.mobile_number}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="CITY">
                    <strong>{data?.company_detail?.address?.city}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="POST CODE">
                    <strong>{data?.company_detail?.address?.post_code}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="ADDRESS">
                    <strong>
                      {data?.company_detail?.address?.street_address}
                    </strong>
                  </Descriptions.Item>
                </Descriptions>
              </>
            ) : null}
            <br></br>

            <Title>Logs </Title>

            <br />
            {data?.logs ? (
              <Timeline mode="left">
                {data.logs.map((item, index) => (
                  <Timeline.Item
                    label={makeLocalTime(item?.created_at)}
                    keys={index}
                  >
                    {item?.message}
                  </Timeline.Item>
                ))}
              </Timeline>
            ) : (
              <Empty />
            )}
          </>
        ) : null}
        <br />
        <br />
      </Wrapper>
      <Remarks
        title=" "
        btn="Submit"
        placement="bottom"
        visible={remark}
        fnc={() => setRemark(false)}
        id={[data?.user_id, auth]}
        delFnc={updateClientAuth}
        refresh={handleRefresh}
      />
      <Remarks
        title=" "
        btn="Submit"
        placement="bottom"
        visible={remarkaccount}
        fnc={() => setRemarkAccount(false)}
        id={[data?.user_id, active]}
        delFnc={updateClientAccount}
        refresh={handleRefresh}
      />
    </Content>
  );
};

export default connect(null, {
  getClientDetails,
  updateClientAuth,
  getClientStatic,
  updateUnitCost,
  updateClientAccount,
  updateClientPassword,
  updateClient,
})(ClientDetails);
